// Constants
function initForm() {
  const crmForm = {
    name: 'contact',
    elem: document.querySelector('.js-contact-form'),
    elemConfirm: document.querySelector('.js-contact-form__confirmation'),
    errorElem: document.querySelector('.js-contact-form__error--form'),
    errorMessage: document.querySelector('.js-contact-form__error--form').dataset.errorMessage,
    ajax: true,
    json: true,
    recaptcha: document.querySelector('.js-contact-form').dataset.recaptchaVersion,

    fields: {
      firstName: {
        elem: document.querySelector('.js-contact-form__first-name'),
        errorElem: document.querySelector('.js-contact-form__error--first-name'),
        errorMessage: document.querySelector('.js-contact-form__error--first-name').dataset.errorMessage,
        valid: false,
      },
      surname: {
        elem: document.querySelector('.js-contact-form__surname'),
        errorElem: document.querySelector('.js-contact-form__error--surname'),
        errorMessage: document.querySelector('.js-contact-form__error--surname').dataset.errorMessage,
        valid: false,
      },
      jobTitle: {
        elem: document.querySelector('.js-contact-form__job-title'),
        errorElem: document.querySelector('.js-contact-form__error--job-title'),
        errorMessage: document.querySelector('.js-contact-form__error--job-title').dataset.errorMessage,
        valid: false,
      },
      companyName: {
        elem: document.querySelector('.js-contact-form__company-name'),
        errorElem: document.querySelector('.js-contact-form__error--company-name'),
        errorMessage: document.querySelector('.js-contact-form__error--company-name').dataset.errorMessage,
        valid: false,
      },
      phoneNumber: {
        elem: document.querySelector('.js-contact-form__phone-number'),
        errorElem: document.querySelector('.js-contact-form__error--phone-number'),
        errorMessage: document.querySelector('.js-contact-form__error--phone-number').dataset.errorMessage,
        valid: false,
        type: 'phone',
        optionalOnPage: true,
      },
      email: {
        elem: document.querySelector('.js-contact-form__email'),
        errorElem: document.querySelector('.js-contact-form__error--email'),
        errorMessage: document.querySelector('.js-contact-form__error--email').dataset.errorMessage,
        valid: false,
      },
      country: {
        elem: document.querySelector('.js-contact-form__country'),
        errorElem: document.querySelector('.js-contact-form__error--country'),
        errorMessage: document.querySelector('.js-contact-form__error--country').dataset.errorMessage,
        valid: false,
      },
      companyType: {
        elem: document.querySelector('.js-contact-form__company-type'),
        errorElem: document.querySelector('.js-contact-form__error--company-type'),
        errorMessage: document.querySelector('.js-contact-form__error--company-type').dataset.errorMessage,
        valid: false,
      },
      interests: {
        elem: document.querySelector('.js-contact-form__interests'),
        errorElem: document.querySelector('.js-contact-form__error--interests'),
        errorMessage: document.querySelector('.js-contact-form__error--interests').dataset.errorMessage,
        valid: false,
        optionalOnPage: true,
      },
      // message: {
      //   elem: document.querySelector('.js-contact-form__message'),
      //   errorElem: null,
      //   errorMessage: null,
      //   valid: false
      // }
    },
  };

  return crmForm;
}

export default {
  initForm,
};
